export default __webpack_public_path__ + "static/media/loud.94da99f2.svg";